export const EDIT_BUTTON_TOOLTIP = 'You will be taken to the results page to make your edits';
